/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import { Text, View, StyleSheet, SafeAreaView, Dimensions } from 'react-native';
import { Icon } from 'react-native-elements';


const EmptySearch = (props) => {
    return (
<SafeAreaView>
<View style={styles.textIcon}>
<Icon name={props.iconName} iconType="material" color="black" size={100} style={styles.textIconIcon} color={props.color} />
<View style={styles.iconTextContainer}>
<Text style={styles.iconText}>{props.title}</Text>
<Text style={styles.iconText}>{props.subtitle}</Text>
</View>
</View>
</SafeAreaView>
)
}

const entireScreenHeight = Dimensions.get('window').height;
const entireScreenWidth = Dimensions.get('window').width;
const styles = StyleSheet.create({
textIcon: {
flex: 1,
flexDirection: 'column',
justifyContent: 'space-between',
alignItems: 'center',
borderWidth: 2,
borderRadius: 20,
borderColor: 'black',
marginTop: entireScreenHeight/30,
marginBottom: entireScreenHeight/30,
padding: 20,
backgroundColor: 'white',
},
iconTextContainer: {
marginTop: 10,
marginBottom: 20,
},
iconText: {
fontSize: 20,
fontWeight: 'bold',
textAlign: 'center',
paddingTop: 10,
},
});

export default EmptySearch;